import type { Editor } from '@tiptap/core';

export type EditorFocusPoint = {
  clientX: number;
  clientY: number;
};

/** Focus the editor at a viewport point, or at the end when no point is provided. */
export function focusEditorAtClientPoint(
  editor: Editor,
  point: EditorFocusPoint | null | undefined,
): void {
  if (!editor.view || editor.isDestroyed) {
    return;
  }

  if (!point) {
    editor.commands.focus('end');
    return;
  }

  const coords = editor.view.posAtCoords({ left: point.clientX, top: point.clientY });
  if (!coords) {
    editor.commands.focus('end');
    return;
  }

  editor.chain().focus().setTextSelection(coords.pos).run();
}
